/**
 * src/app/web-vitals.tsx
 *
 * Web Vitals RUM (Real User Monitoring) Client Component.
 *
 * Next.js `useReportWebVitals` hook her Core Web Vital metric kaydedildiğinde
 * tetiklenir (LCP, INP, CLS, FCP, TTFB, FID). Metric'i `/api/vitals` endpoint'ine
 * `fetch` ile gönderir; `keepalive: true` sayesinde sayfa unload sırasında bile
 * (kullanıcı tab kapatırken) istek tamamlanır.
 *
 * Layout'a mount edilir (root, locale layout veya public layout — herhangi
 * birinden bir kere). Boş JSX (`null`) render eder; sadece side-effect.
 *
 * KVKK: metric verisi anonim — IP/email/user-id gönderilmez. Endpoint
 * tarafında URL query string strip'lenir, UA family seviyesinde tutulur.
 *
 * Performance:
 *   - fetch keepalive: sayfa unload'da bile gider, browser block etmez
 *   - sendBeacon API alternatif olabilir ama JSON body için fetch+keepalive
 *     daha esnek
 *   - Hata loglaması yok (silent fail) — RUM verisi best-effort
 */
'use client'

import { useReportWebVitals } from 'next/web-vitals'

export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    // Sadece istenen metric'leri gönder (ek metric'ler ileride genisletilebilir)
    const allowedNames = new Set(['LCP', 'INP', 'CLS', 'FCP', 'TTFB', 'FID'])
    if (!allowedNames.has(metric.name)) return

    const payload = {
      name: metric.name,
      value: metric.value,
      id: metric.id,
      rating: metric.rating,
      url: window.location.href,
      navigationType: metric.navigationType,
    }

    try {
      void fetch('/api/vitals', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      })
    } catch {
      // Silent fail — RUM verisi best-effort, sayfa render'ı etkilemez
    }
  })

  return null
}
